"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/tree/style/css");

var _tree = _interopRequireDefault(require("antd/es/tree"));

var _react = _interopRequireWildcard(require("react"));

var _uuid = _interopRequireDefault(require("uuid"));

require("./treeNode.scss");

var _TreeQuestionNode = _interopRequireDefault(require("./TreeQuestionNode"));

var _TreeOptionItem = _interopRequireDefault(require("./TreeOptionItem"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// @ts-nocheck
class ChooseYourOwnAdventure extends _react.Component {
  constructor(props) {
    super(props);

    this.addQuestion = optionId => {
      const {
        questions,
        options
      } = this.state;
      const option = options.get(optionId);

      if (option) {
        const id = (0, _uuid.default)();
        this.setState({
          questions: new Map(questions.set(id, {
            id,
            optionIds: [],
            text: ''
          })),
          options: new Map(options.set(optionId, { ...option,
            questionId: id
          })),
          isUnsaved: true
        });
      }
    };

    this.addOption = questionId => {
      const {
        questions,
        options
      } = this.state;
      const question = questions.get(questionId);

      if (question) {
        const id = (0, _uuid.default)();
        this.setState({
          questions: new Map(questions.set(questionId, { ...question,
            optionIds: [...question.optionIds, id]
          })),
          options: new Map(options.set(id, {
            id,
            text: ''
          })),
          isUnsaved: true
        });
      }
    };

    this.updateQuestion = question => {
      const {
        questions
      } = this.state;
      this.setState({
        questions: new Map(questions.set(question.id.toString(), question)),
        isUnsaved: true
      });
    };

    this.updateOption = option => {
      const {
        options
      } = this.state;
      this.setState({
        options: new Map(options.set(option.id.toString(), option)),
        isUnsaved: true
      });
    };

    this.removeQuestion = id => {
      const {
        firstId,
        questions,
        options
      } = this.state;

      if (id === firstId) {
        // If id equals firstId, then we delete the whole tree
        const newFirstId = (0, _uuid.default)();
        const newQuestions = new Map();
        newQuestions.set(newFirstId, {
          id: newFirstId,
          optionIds: [],
          text: ''
        });
        this.setState({
          firstId: newFirstId,
          questions: newQuestions,
          options: new Map(),
          isUnsaved: false
        });
      } else {
        const question = questions.get(id);

        if (question) {
          // Remove references to id from options.questionId
          options.forEach(o => {
            if (o.questionId === id) {
              options.set(o.id.toString(), { ...o,
                questionId: undefined
              });
            }
          });
          questions.delete(id); // Delete child options of the removed question

          question.optionIds.forEach(optionId => {
            this.removeOption(optionId);
          });
          this.setState({
            questions: new Map(questions),
            options: new Map(options),
            isUnsaved: true
          });
        }
      }
    };

    this.removeOption = id => {
      const {
        questions,
        options
      } = this.state;
      const option = options.get(id);

      if (option) {
        // Delete child questions of removed option
        if (option.questionId) {
          this.removeQuestion(option.questionId);
        } // Remove references to removed option from questions.optionIds


        questions.forEach(q => {
          if (q.optionIds.includes(id)) {
            questions.set(q.id.toString(), { ...q,
              optionIds: q.optionIds.filter(optionId => optionId !== id)
            });
          }
        });
        options.delete(id);
        this.setState({
          questions: new Map(questions),
          options: new Map(options),
          isUnsaved: true
        });
      }
    };

    this.getQuestion = id => {
      return this.state.questions.get(id);
    };

    this.getOption = id => {
      return this.state.options.get(id);
    };

    this.mapQuestionToTreeNode = id => {
      const {
        disabled
      } = this.props;
      const {
        questions
      } = this.state;
      const question = questions.get(id);
      return {
        title: /*#__PURE__*/_react.default.createElement(_TreeQuestionNode.default, {
          disabled: disabled,
          question: question,
          updateQuestion: this.updateQuestion,
          removeQuestion: this.removeQuestion,
          addOption: this.addOption
        }),
        key: `question-${id}`,
        children: question.optionIds.map(this.mapOptionToTreeNode)
      };
    };

    this.mapOptionToTreeNode = id => {
      const {
        disabled
      } = this.props;
      const {
        options
      } = this.state;
      const option = options.get(id);
      return {
        title: /*#__PURE__*/_react.default.createElement(_TreeOptionItem.default, {
          disabled: disabled,
          option: option,
          addQuestion: this.addQuestion,
          updateOption: this.updateOption,
          removeOption: this.removeOption
        }),
        key: `option-${id}`,
        children: option.questionId ? [this.mapQuestionToTreeNode(option.questionId)] : []
      };
    };

    this.generateTreeData = () => {
      const {
        firstId
      } = this.state;
      return [this.mapQuestionToTreeNode(firstId)];
    };

    if (props.tree && props.firstId) {
      this.state = {
        firstId: props.firstId,
        questions: new Map(props.tree.questions),
        options: new Map(props.tree.options),
        isUnsaved: false
      };
    } else {
      const firstId = (0, _uuid.default)();
      const questions = new Map();
      const options = new Map();
      questions.set(firstId, {
        id: firstId,
        optionIds: [],
        text: ''
      });
      this.state = {
        firstId,
        questions,
        options,
        isUnsaved: false
      };
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.isUnsaved && this.state.isUnsaved) {
      const {
        updateTree
      } = this.props;
      const {
        questions,
        options,
        firstId
      } = this.state;
      updateTree({
        questions,
        options
      }, firstId);
      this.setState({
        isUnsaved: false
      });
    }
  }

  render() {
    return /*#__PURE__*/_react.default.createElement(_tree.default, {
      showLine: true,
      defaultExpandAll: true,
      treeData: this.generateTreeData(),
      selectable: false
    });
  }

}

var _default = ChooseYourOwnAdventure;
exports.default = _default;